const KEY = 'office-hours-pending'

// Like portal-auth and TA drafts, this is tab-local recovery state. It never
// establishes permission; every recovery revalidates the token server-side.
export function loadOfficeHoursPending(token, studentIds) {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY) || 'null')
    if (!saved) return new Map()
    if (saved.token !== token || !Array.isArray(saved.requests)) {
      sessionStorage.removeItem(KEY)
      return new Map()
    }
    return new Map(saved.requests.slice(0, 100).filter(([studentId, request]) => studentIds.includes(studentId)
      && /^ci1_[0-9a-f]{32}$/.test(request?.id) && ['reserve', 'cancel'].includes(request?.operation)
      && request?.payload && typeof request.payload === 'object'
      && (request.operation !== 'reserve' || request.payload.primary_student_id === studentId)))
  } catch {
    return new Map()
  }
}

export function saveOfficeHoursPending(token, requests) {
  try {
    if (!requests.size) sessionStorage.removeItem(KEY)
    else sessionStorage.setItem(KEY, JSON.stringify({ token, requests: [...requests.entries()].slice(0, 100) }))
  } catch {
    // The live page still retains its original identity if browser storage is blocked.
  }
}
